// priority 1...10
// blocker
// emergency

export const PriorityPaleBGPaletteDark: any = {
    1: '#AFE7FA',
    2: '#AFE7FA',
    3: '#BFE0FF',
    4: '#BFE0FF',
    5: '#BED0FF',
    6: '#FFD9BA',
    7: '#FFC5B3',
    8: '#FFC5B3',
    9: '#FFC5B3',
    10: '#FFC5B3',
    50: '#F8B9B8',
    100: '#F8B9B8'
}
